import React from "react";
// import EditIcon from "@mui/icons-material/Edit";

import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import { useAppContext } from "../../Lib/ContextLib";
import CustomSelect from "../../Components/CustomSelect";

export default function Admin() {
  const { accessObject } = useAppContext();
  const [isEdit, setIsEdit] = React.useState(false);
  // const [rowValue, setRowValue] = React.useState();
  const [tableData, setTableData] = React.useState([]);
  const [searchPhoneNo, setSearchPhoneNo] = React.useState("");
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const LoginSchema = Yup.object().shape({
    FristName: Yup.string().required("FristName is required"),
    LastName: Yup.string().required("LastName is required"),
    Phone: Yup.string().required("Phone is required"),
    Email: Yup.string().required("email is required"),
    Password: Yup.string().required("Phone is required"),
    Status: Yup.string().required("Status is required"),
  });
  React.useEffect(() => {
    getPlayerList();
  }, []);
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getPlayerList = () => {
    setLoader(true);
    axios(`${API_URL}/api/player/get-player`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        console.log("dataTable.dataRows :::", response?.data?.message);
        setTableData(response?.data?.message);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const searchingData = [];
  let data = [];
  if (searchPhoneNo) {
    console.log("searchPhoneNo", searchPhoneNo, tableData);

    data = tableData.filter((item) => {
      console.log("data", item?.phoneNo);

      if (item.phoneNo !== undefined) {
        return Object.values(item?.phoneNo)
          .join("")
          .toLowerCase()
          .includes(searchPhoneNo?.toLowerCase());
      }
      return false;
    });
    console.log("data", data);
    data?.map(
      (dataItem) =>
        dataItem.role === "admin" &&
        dataItem.playerDeleteStatus === "notDeletedUser" &&
        searchingData?.push(dataItem)
    );
  } else {
    tableData?.map(
      (dataItem) =>
        dataItem.role === "admin" &&
        dataItem.playerDeleteStatus === "notDeletedUser" &&
        searchingData?.push(dataItem)
    );
  }
  return (
    <div>
      {isEdit ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              {" "}
              <Formik
                initialValues={{
                  FristName: "",
                  LastName: "",
                  Phone: "",
                  Email: "",
                  Password: "",
                  Status: "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  console.log(values);
                  alert("Form is validated! Submitting the form...");
                }}
              >
                  {({ touched, errors, values }) => (
                    <Form>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>First Name <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="FristName"
                              placeholder="Enter first name"
                              autocomplete="off"
                              className={`mt-1 form-control ${touched.FristName && errors.FristName ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="FristName" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Last Name <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="LastName"
                              placeholder="Enter last name"
                              autocomplete="off"
                              className={`mt-1 form-control ${touched.LastName && errors.LastName ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="LastName" className="invalid-feedback" />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Phone Number <span className="text-danger">*</span></label>
                            <Field
                              type="number"
                              name="Phone"
                              placeholder="Enter phone number"
                              autocomplete="off"
                              className={`mt-1 form-control ${touched.Phone && errors.Phone ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="Phone" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Email Address <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="Email"
                              placeholder="name@example.com"
                              autocomplete="off"
                              className={`mt-1 form-control ${touched.Email && errors.Email ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="Email" className="invalid-feedback" />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Password <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="Password"
                              placeholder="Enter password"
                              autocomplete="off"
                              className={`mt-1 form-control ${touched.Password && errors.Password ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="Password" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <CustomSelect
                            label="Account Status"
                            name="Status"
                            options={[
                              { value: "", label: "Select Status" },
                              { value: "onverified", label: "Unverified" },
                              { value: "Active", label: "Active" },
                              { value: "InActive", label: "Inactive" },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="d-flex mt-4 pt-4 border-top">
                        <button
                          style={{ width: "110px", height: "38px" }}
                          type="submit"
                          className="btn btn-primary mr-2"
                        >
                          Submit
                        </button>
                        <button
                          style={{ width: "110px", height: "38px" }}
                          type="button"
                          className="btn btn-secondary ms-2"
                          onClick={() => setIsEdit(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div
              class="pl-4 pr-4 pt-4"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 class="card-title">
                <b>Admin</b>
              </h3>
              <div>
                <input
                  class="input-simple"
                  type="email"
                  placeholder="Phone No."
                  value={searchPhoneNo}
                  onChange={(e) => setSearchPhoneNo(e.target.value)}
                />
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>SrNo</th>
                    <th style={{ textAlign: "center" }}>Player Id</th>
                    <th style={{ textAlign: "center" }}>User Name</th>
                    <th style={{ textAlign: "center" }}>Phone No.</th>

                    <th style={{ textAlign: "center" }}>Balance</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                {accessObject?.getStaffAdminList === true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {searchingData?.length > 0 ? (
                            <>
                              {searchingData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <tr key={index}>
                                    <td style={{ textAlign: "center" }}>
                                      {index + 1 + pagination.start}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(item.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.playerId}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.name}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.phoneNo}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.balance}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.playerStatus}
                                    </td>
                                  </tr>
                                ))}{" "}
                            </>
                          ) : (
                            <EmptyState colSpan={7} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                      <td colSpan={7}>
                        <h5 className="text-center">Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getStaffAdminList === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getStaffAdminList === true &&
              searchingData.length !== 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={searchingData.length}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
}
